import { createContextQuick } from '@components/quick-context';
import { ContentFormState } from './content.form.types';

export const [ContentFormContext, useContentFormContext] = createContextQuick<ContentFormState>();
